import api from "@/services/api.service";
import { ActionTree } from "vuex";
import { RootState } from "@/store/types";
import { Group, AreaState, GroupWithPermissions, Tenant } from "@/store/areas/types";
import { CancelToken } from "axios";
import { groupsApi } from "@/services/api.groups.service";

export const actions: ActionTree<AreaState, RootState> = {
	async createArea({ commit }, payload: Group) {
		return await api.addArea(payload);
	},

	async updateArea({ commit }, payload: Group) {
		return await api.updateArea(payload);
	},

	async getArea({ commit }, areaId: number) {
		return await api.getArea(areaId);
	},

	/**
	 * @deprecated This method is deprecated, use the AreaTreeSelect and fetchAreaDictionary instead.
	 */
	async getAreaList({ commit }, cancelToken: CancelToken) {
		const data = (await api.getAreaList(cancelToken)) as GroupWithPermissions[];
		commit("setAreaList", data as GroupWithPermissions[]);
	},

	async deleteArea({ commit }, areaId: number) {
		return await api.deleteArea(areaId);
	},

	async enableArea({ commit }, areaId: number) {
		return await api.enableArea(areaId);
	},

	async disableArea({ commit }, areaId: number) {
		return await api.disableArea(areaId);
	},

	async getTenants({ commit }) {
		const { data } = await api.getTenants();
		return data;
	},

	async getWeeklyDisarmSchedule({ commit }, payload: { areaId: number; regionUrl: string }) {
		const { data } = await api.getWeeklyDisarmSchedule(payload.areaId, payload.regionUrl);
		return data;
	},

	async getResponsesByArea({ commit }, groupID: number) {
		const data = await api.responsesByArea({ GroupID: groupID });
		return data;
	},

	async fetchAreaDictionary({ commit }, regionUrl?: string | null) {
		const data = await groupsApi.getAreaDictionary(regionUrl);
		commit("setAreaDictionary", data);
	}
};
